import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Admin from "@/components/site/Admin";
import Article from "@/components/site/Article";
import "@/App.css";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";
import Header, { scrollToSection } from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Capabilities from "@/components/site/Capabilities";
import CapitalStack from "@/components/site/CapitalStack";
import Process from "@/components/site/Process";
import WhoWeWorkWith from "@/components/site/WhoWeWorkWith";
import WhyJeet from "@/components/site/WhyJeet";
import FeaturedRequirements from "@/components/site/FeaturedRequirements";
import Insights from "@/components/site/Insights";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const pending = sessionStorage.getItem("jas_scroll_to");
    if (pending && window.location.pathname === "/") {
      sessionStorage.removeItem("jas_scroll_to");
      setTimeout(() => scrollToSection(pending), 900);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/insights/:slug" element={<Article />} />
        <Route
          path="/"
          element={
            <div className="App grain">
              <Seo
                title="Jeet Advisory Services | Capital Advisory & Structured Finance"
                siteName="Jeet Advisory Services"
                description="Jeet Advisory Services helps businesses and promoters identify appropriate capital structures across debt, NBFC, private credit, structured finance, project finance and capital raising."
                image="/og.png"
                jsonLd={{
                  "@context": "https://schema.org",
                  "@type": "FinancialService",
                  name: "Jeet Advisory Services",
                  description:
                    "Capital advisory and financial consulting firm helping businesses and promoters identify appropriate capital structures across debt, private credit, structured finance, project finance and capital raising.",
                  email: "jeetadvisoryservices@gmail.com",
                  telephone: "+91 97022 63336",
                  areaServed: "IN",
                  founder: {
                    "@type": "Person",
                    name: "Sharanjit Singh Panesar",
                    jobTitle: "Founder & Capital Advisor",
                  },
                }}
              />
              <Header />
              <main>
                <Hero />
                <Marquee />
                <About />
                <Capabilities />
                <CapitalStack />
                <Process />
                <WhoWeWorkWith />
                <WhyJeet />
                <FeaturedRequirements />
                <Insights />
                <Contact />
              </main>
              <Footer />
              <Toaster position="top-center" theme="dark" />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
